import { ChatWidgetStatus, DeviceType } from '../../types';
import * as actionNames from './names';
import { IAction } from '../../../reducer-factory';

export const runSetStatus = (status: ChatWidgetStatus): IAction<ChatWidgetStatus> => ({
  type: actionNames.SET_STATUS,
  value: status,
});

export const runSetIsWindowOpen = (isOpen: boolean): IAction<boolean> => ({
  type: actionNames.SET_IS_WINDOW_OPEN,
  value: isOpen,
});

export const runSetError = (error: string | null): IAction<string | null> => ({
  type: actionNames.SET_ERROR,
  value: error,
});

export const runSetIsLegalAccepted = (isAccepted: boolean): IAction<boolean> => ({
  type: actionNames.SET_IS_LEGAL_ACCEPTED,
  value: isAccepted,
});

export const runSetDeviceType = (deviceType: DeviceType): IAction<DeviceType> => ({
  type: actionNames.SET_DEVICE_TYPE,
  value: deviceType,
});

export const runSetIsAgentsAvailable = (isAvailable: boolean): IAction<boolean> => ({
  type: actionNames.SET_IS_AGENTS_AVAILABLE,
  value: isAvailable,
});

export const runSetFloatingButtonsHidden = (isHidden: boolean): IAction<boolean> => ({
  type: actionNames.SET_FLOATING_BUTTONS_HIDDEN,
  value: isHidden,
});
